export const blackoutLabelFromMemberType = (customer, translateFn) => {
  const memberType = customer?.user?.memberType
  if (!memberType) return null
  const labelKey = `rdMemberNotification-${memberType}`
  const labelFound = global.tridionLabels[labelKey]
  if (!labelFound) return null
  return translateFn(labelKey)
}
